import { FC } from 'react';
export const FJLogo: FC = () => (
	<>
		<img src="fwg_logo.svg" alt="IVA | Expert Advice from Freeman Jones | Individual Voluntary Arrangement" className='logo'></img>
	</>
)
